"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from "react";
import { cleanProps, cn } from "../../../utils/index.js";
import { DrawerToPopover } from "../../DrawerToPopover/index.js";
import { NonOpenableFilterChip } from "./NonOpenableFilterChip.js";
const OpenableFilterChip_OpenableFilterChip = /*#__PURE__*/ forwardRef(function({ children, isOpen, onOpenChange, defaultOpen, title = 'openable-filter-chip-title', ...props }, ref) {
    const [internalIsOpen, setInternalIsOpen] = useState(defaultOpen ?? false);
    const isControlled = void 0 !== isOpen;
    const currentIsOpen = isControlled ? isOpen : internalIsOpen;
    const { label, helperText, className, id, name, disabled, onClick, selected, onSelectionChange, iconLeft, customIcon, value, count, filterType, type, elevated, emphasis, showCheckIcon, customNode, ...drawerToPopoverProps } = props;
    useEffect(()=>{
        if (isControlled && void 0 !== isOpen) setInternalIsOpen(isOpen);
    }, [
        isControlled,
        isOpen
    ]);
    const handleOpenChange = (open)=>{
        if (!isControlled) setInternalIsOpen(open);
        onOpenChange?.(open);
    };
    const nonOpenableChipProps = {
        label,
        helperText,
        id,
        name,
        disabled,
        onClick,
        selected,
        onSelectionChange,
        iconLeft,
        customIcon,
        value,
        count,
        filterType,
        type,
        elevated,
        emphasis,
        showCheckIcon,
        customNode
    };
    return /*#__PURE__*/ jsx(DrawerToPopover, {
        triggerNode: /*#__PURE__*/ jsx(NonOpenableFilterChip, {
            ref: ref,
            ...nonOpenableChipProps,
            className: cn(className, 'openable-filter-chip')
        }),
        disableTriggerFocus: true,
        open: currentIsOpen,
        onOpenChange: handleOpenChange,
        defaultOpen: defaultOpen,
        title: title,
        ...cleanProps(drawerToPopoverProps, [
            'opens'
        ]),
        children: children
    });
});
export { OpenableFilterChip_OpenableFilterChip as OpenableFilterChip };
